import { ApiEndpoints } from "../../utils/app-constants";
import { toShortDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS } from "../utilities/type-models";

export class WindloadChecklistReportDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(startDate: Date, endDate: Date) {
        var startDateStr = toShortDate(startDate);
        var endDateStr = toShortDate(endDate);

        const searchParams = new URLSearchParams();
        searchParams.append('StartDate', startDateStr);
        searchParams.append('EndDate', endDateStr);

        var args = searchParams.toString();
        this.url = `${ApiEndpoints.WINDLOAD_CHECKLIST_REPORT}?${args}`;
        this.filename = `WindloadChecklist_${startDateStr}_${endDateStr}`;
    }

}
